<template>
	<section class="container margin-module" :class="{ 'smaller-logo': true }">
		<div class="inner">
			<h2 v-if="data.title" class="titler text-center text-uppercase font--900 font-size--40">
				{{ data.title }}
			</h2>
			<ul class="spnsrblc" v-if="postItems && postItems.length">
				<li class="spnsrblck-block" v-for="(sponsor, l) in postItems" :key="l">
					<AcfLink :data="{ url: sponsor.acf.link, target: '_blank' }">
						<WpImage :img-url="fixUrl(sponsor.acf.image.url)" />
					</AcfLink>
				</li>
			</ul>
		</div>
	</section>
</template>

<script>
import WpImage from '@/components/elements/WpImage'
import AcfLink from '@/components/elements/AcfLink'

import { mapOrder } from '@/helpers'
import { mapActions, mapGetters } from 'vuex'

export default {
	name: 'sponsors',
	props: ['data'],
	data() {
		return {
			postType: 'sponsors',
			postItems: [],
			loadingPostsStatus: 'loading',
			devUrl:
				process.env.NODE_ENV === 'development' && window.WPVUE && window.WPVUE.home
					? window.WPVUE.home.replace(/\/$/, '')
					: '',
		}
	},
	components: {
		AcfLink,
		WpImage,
	},
	mounted() {
		const VM = this
		if (!VM.data) return false
		if (VM.includePosts) {
			VM.loadPosts({
				type: VM.postType,
				include: VM.includePosts,
				limit: VM.includePosts.length,
			}).then((e) => {
				//load rest of posts
				if (e === 'success' && VM.postItems.length < VM.includePosts.length) {
					VM.loadPosts({
						type: VM.postType,
						exclude: [...VM.includePosts],
						limit: VM.includePosts.length - VM.postItems.length,
					})
				}
			})
		}
	},
	computed: {
		includePosts() {
			return this.data.selected_sponsors || 0
		},

		loadOpt() {
			const VM = this
			if (!VM.data) return []
			const opt = {
				type: VM.postType || 'sponsors',
				include: VM.includePosts,
				limit: VM.includePosts.length || 3,
			}
			return opt
		},
	},

	methods: {
		...mapActions(['getPost']),
		fixUrl(imageUrl) {
			if (imageUrl && this.devUrl && !imageUrl.includes(this.devUrl)) imageUrl = this.devUrl + imageUrl
			return imageUrl
		},
		loadPosts(options) {
			if (!options) {
				options = this.loadOpt
			}
			const VM = this
			VM.loadingPostsStatus = 'loading'
			return VM.getPost(options).then((res) => {
				if (res.data && res.data.posts && res.data.posts.length) {
					if (VM.includePosts) {
						VM.postItems.push(...mapOrder(res.data.posts, VM.includePosts, 'id'))
					} else {
						VM.postItems.push(...res.data.posts)
					}
				}
				VM.loadingPostsStatus = 'success'
				return VM.loadingPostsStatus
			})
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';
.module-sponsors {
	&.smaller-logo {
		.spnsrblc {
			margin: -12px !important;
		}
		.spnsrblck-block {
			max-width: 16.66% !important;
			padding: 12px !important;
			@include mquery($tablet) {
				max-width: 25% !important;
			}
			@include mquery($phone) {
				max-width: 50% !important;
			}
		}
	}
	.titler {
		margin-top: 0;
		margin-bottom: 50px;
		@include mquery($tablet) {
			margin-bottom: 40px;
		}
		@include mquery($phone) {
			margin-bottom: 30px;
		}
	}
	.inner {
		background-color: var(--light);
		@include mquery($tablet) {
		}
		@include mquery($phone) {
		}
	}
	.spnsrblc {
		padding: 0;
		margin: 0;
		list-style: none;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		margin: -25px;
		@include mquery($phone) {
			margin: -15px;
		}

		.spnsrblck-block {
			width: 100%;
			max-width: 25%;
			padding: 25px;
			display: flex;
			align-items: center;
			@include mquery($tablet) {
				max-width: 25%;
			}
			@include mquery($phone) {
				max-width: 100%;
				padding: 15px;
			}
			a {
				height: auto;
				padding-bottom: 0;
				display: block;
				text-align: center;
				height: 0;
				padding-bottom: 50%;
				position: relative;
				width: 100%;
				&:hover {
					img {
						transform: scale(1.05);
					}
				}
				.wp-image-vue {
					height: inherit;
					padding-bottom: inherit;
					position: absolute;
					text-align: center;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
				}
				img {
					position: relative;
					transition: all 0.2s ease-in-out;
					max-width: 100%;
					height: 100%;
					width: 100%;
					position: absolute;
					left: 0;
					top: 0;
					right: 0;
					bottom: 0;
					object-fit: contain;
				}
			}
			span {
				display: none;
			}
		}
	}
}
</style>
